import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/zh-TW'
import axios from 'axios'
import VueAxios from 'vue-axios'
import firebase from 'firebase/app';
import { getAuth } from 'firebase/auth';

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)
Vue.use(ElementUI, { locale })
Vue.use(VueAxios, axios)
const auth = getAuth();
router.beforeEach((to, from, next) => {
  if (to.name !== 'Login' && !getAuth().currentUser) next({ name: 'Login' })
  else next()
})
new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
